import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import { LoginUser } from "../services/btc-api.service";
import { store } from "../redux/store";
import { setUser } from "../redux/user";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  return (
    <div className="login-page">
      <form
        method="POST"
        onSubmit={async (e) => {
          e.preventDefault();

          const payload = {
            usernameSrNo: email,
            password,
          };

          const res = await LoginUser(payload);

          if (res && res.token) {
            localStorage.setItem("token", res.token);

            store.dispatch(setUser(res.user));

            window.location.replace("/");
          }
        }}
      >
        <img src="form-logo.png" alt="form-logo.png" />
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="text"
          required
          placeholder="USER ID"
        />
        <input
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          type="password"
          required
          placeholder="PASSWORD"
        />

        <div className="extra-actions">
          <div className="remember">
            <input type="checkbox" />
            <span>Remember</span>
          </div>
          <div className="forgot">
            <span>Forgot your password</span>
          </div>
        </div>

        <button type="submit">Login</button>
        <button className="outline" onClick={() => navigate("/signup")}>
          Register
        </button>
      </form>
    </div>
  );
}
